import { createSelector } from 'reselect'

const selector = state => state.myLoadsReducer

export const myLoadFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const myLoadLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const myLoadLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const myLoadErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const myLoadLoadsSelector = createSelector(
  [selector],
  ({ loads }) => loads
)

export const myLoadNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const myLoadSelector = createSelector(
  [selector],
  myLoads => myLoads
)
